module.exports = __webpack_public_path__ + "img/map-4-f@2x.0483ae6d.png";